import axios from 'axios'

// 创建axios实例
const http = axios.create({
  baseURL: 'https://ver.timelywise.cn', // 设置基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    console.log('请求发送:', config)
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
http.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response.data
  },
  error => {
    // 对响应错误做点什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 封装ajax函数以兼容现有代码
export const ajax = (options) => {
  const { url, method = 'get', data, success, error } = options
  
  http({
    url,
    method,
    [method.toLowerCase() === 'get' ? 'params' : 'data']: data
  })
  .then(response => {
    if (success) success(response)
  })
  .catch(err => {
    if (error) error(err)
    else console.error('请求失败:', err)
  })
}

export default http

